export const FETCH_EXPERIENCES_REQUEST = 'FETCH_EXPERIENCES_REQUEST';
export const FETCH_EXPERIENCES_SUCCESS = 'FETCH_EXPERIENCES_SUCCESS';
export const FETCH_EXPERIENCES_FAILURE = 'FETCH_EXPERIENCES_FAILURE';
export const SET_EXPERIENCES_CATEGORY = 'SET_EXPERIENCES_CATEGORY';
export const SET_EXPERIENCES_SEARCH = 'SET_EXPERIENCES_SEARCH';
